/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Country = {
    properties: {
        code: {
            type: 'CountryCode',
            isRequired: true,
        },
        name: {
            type: 'Translation',
            isRequired: true,
        },
    },
} as const;
